import React from "react";

function NotFound() {
  return <div className="p-5">Aucune page ne correspond à cette adresse.</div>;
}

export default NotFound;
